import Request from '@/utils/request'

// 代理查询
export function apiSearchAgent(presentId) {
  return Request({
    url: `/api/v2/app/agent/bind/host?presentId=${presentId}`,
    method: 'get',
  })
}

// 移除主播
export function apiDeleteAgent(presentId) {
  return Request({
    url: `/api/v2/app/agent/bind/host/${presentId}`,
    method: 'delete',
  })
}

// 获取用户需要进入的 代理中心页面
export function agentPageTypeApi() {
  return Request({
    url: '/api/v2/app/agent/homepage/before',
    method: 'get',
  })
}

// 代理中心-新版主页面接口
export function apiFetchInviteV2HomePage() {
  return Request({
    url: '/api/v2/app/agent/homepage/v2',
    method: 'get',
  })
}

// Dashboard 上周看板数据
export function apiFetchDashboardLast() {
  return Request({
    url: '/api/v2/app/dashboard/last',
    method: 'get',
  })
}

// 代理中心-设置是否访问过
export function agentGuidePageStatusSetApi() {
  return Request({
    url: '/api/v2/app/agent/newerGuide/upload',
    method: 'put',
  })
}

// 代理中心-规则页面
export function rules2PageApi() {
  return Request({
    url: '/api/v2/app/agent/rule/v2',
    method: 'get',
  })
}

// 更新联系方式
export function updateContactInfoApi(data) {
  return Request({
    url: '/api/v2/app/contact/info',
    method: 'put',
    data,
  })
}

// 获取联系方式
export function getContactInfoApi(params) {
  return Request({
    url: `/api/v2/app/contact/info/${params.toUid}`,
    method: 'get',
    params: {
      scene: params.scene,
      presentId: params.presentId,
    },
  })
}

// 获取联系资料页(本人Contact Card+绑定列表)
export function getAllContactInfoApi(params) {
  return Request({
    url: '/api/v2/app/contact/main',
    method: 'get',
    params,
  })
}

// 发送联系方式消息
export function sendContactInfoApi(data) {
  return Request({
    url: '/api/v2/app/contact/sendMsg',
    method: 'post',
    data,
  })
}

// 二级代理拉新情况
export function apiFetchSubAgentInvite(params) {
  return Request({
    url: '/api/v2/app/sub/agent/invite',
    method: 'get',
    params,
  })
}

// 二级代理分成明细
export function apiFetchSubAgentCommissionList(params) {
  return Request({
    url: '/api/v2/app/sub/agent/commission/list',
    method: 'get',
    params,
  })
}

// 二级代理总收益
export function apiFetchSubAgentCommissionTotal(params) {
  return Request({
    url: '/api/v2/app/sub/agent/commission/total',
    method: 'get',
    params,
  })
}

// 二级代理轮播
export function apiFetchSubAgentCarousel() {
  return Request({
    url: '/api/v2/app/sub/agent/carousel',
    method: 'get',
  })
}

// 主播绑定二级代理
export function apiInviteAgentBind(inviteCode) {
  return Request({
    url: '/api/v2/app/agent/invited/bind',
    method: 'post',
    data: { inviteCode },
  })
}

// 获取邀请码对应代理信息
export function apiFetchInvitedAgentUsed(invitedCode) {
  return Request({
    url: '/api/v2/app/agent/invited/used',
    method: 'get',
    params: { invitedCode },
  })
}
